/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { truncateString } from '../../utils/helpers/string'
import { useDisplayStyle } from '../../utils/styles/display'
import { useFontStyle } from '../../utils/styles/font'
import { usePaddingStyle } from '../../utils/styles/padding'
import { useSizeStyle } from '../../utils/styles/size'
import ConditionalLink from '../actions/ConditionalLink'

const Text = ({ children, value, truncate, hideIfEmpty, title, ...props }) => {
  value = value || children
  if (truncate) value = truncateString(value, truncate)

  const style = css`
    ${useDisplayStyle(props)}
    ${useFontStyle(props)}
    ${useSizeStyle(props)}
  `

  if (hideIfEmpty && !value) return false

  return (
    <ConditionalLink {...props}>
      <p css={style} className="text" title={title}>
        {value}
      </p>
    </ConditionalLink>
  )
}

export const Title = props => <Text size="h2" marginBottom={0.4} bold {...props} />
export const Paragraph = props => <Text size="p" marginBottom={0.4} {...props} />
export const SmallText = props => <Text size="small" {...props} />
export const Label = props => <Text size="small" marginBottom={0.4} bold {...props} />
export const Span = props => <Text inline {...props} />
export const Bold = props => <Span bold {...props} />

export default Text
